import { render, staticRenderFns } from "./ModalAddDistributor.vue?vue&type=template&id=2e50f53c&"
import script from "./ModalAddDistributor.vue?vue&type=script&lang=js&"
export * from "./ModalAddDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports